import fb from "../firebase";
import {useFirestore, UseFirestoreOptions} from "./useFirestore";


// TODO: refac para usar snapshot global
export const useEstados = (options?: UseFirestoreOptions): [any[], boolean] => {
  return useFirestore({
    query: () => fb.db.collection('estados'),
    queryKey: 'estados',
    options,
  });
}

export const useGetCidades = (args: {estado?: string}, options?: UseFirestoreOptions): [any[], boolean] => {
  const {estado} = args;
  return useFirestore({
    args,
    query: ({estado}) => fb.db.collection('cidades')
      .where('estado', '==', estado),
    queryKey: `cidades-${estado}`,
    options,
  });
}
